import { Button, Space } from "antd";
import { Link } from "react-router-dom";
import CloseIcon from "../../assets/icons/CloseIcon";
import SuccessCheck from "../../assets/icons/SuccessCheck";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function CongratulationsProfileComplete({
  handleClose,
  ...rest
}: ModalComponentProps) {
  return (
    <CustomModal
      {...rest}
      title=""
      closeIcon={null}
      handleClose={() => handleClose(true)}
      width={460}
      footer={null}
    >
      <Space align="center" className="justify-between w-full">
        <div className="text-header text-[22px] font-semibold flex items-center gap-2">
          <div className="p-1.5">
            <SuccessCheck />
          </div>
          Congratulations!
        </div>

        <Button
          className="normal-button !border-none"
          icon={<CloseIcon />}
          onClick={() => handleClose(true)}
        />
      </Space>
      <div className="my-6">
        <p className="text-body-text text-base font-normal mb-4">
          Welcome to sBusiness.xyz Enjoy your 1 Month free Subscription!
        </p>
        <p className="h-8 px-2.5 py-1 bg-[#fff8df] rounded  items-center inline-flex text-neutral text-sm">
          Would you like to verify your email address now?
        </p>
      </div>

      <Space className="w-full" size={12}>
        <Button
          className="normal-dark-button modal-button"
          onClick={() => handleClose(true)}
          size="middle"
        >
          Later
        </Button>
        <Link to="/verify-account">
          <Button
            className="modal-button"
            type="primary"
            size="middle"
            onClick={() => handleClose(true)}
          >
            Verify Now
          </Button>
        </Link>
      </Space>
    </CustomModal>
  );
}
